// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomPanel_wrapper__qpT41"};